import React, {Component} from 'react';
import Users from './Users';
import LopStatus from './LopStatus';
import TardySweep from './TardySweep';
import Rosters from './Rosters';
import Library from './Library';
import GPA from './GPA';
import Check from './Check';
import Reports from './Reports';
import ViewByStudent from './ViewByStudent';

const R = require('ramda');

class Main extends Component {

  componentDidUpdate(prevProps, prevState) {
    if (!prevProps.loggedIn && this.props.loggedIn) {
      this.ref = this.props.db.ref('students');
      this.getStudentList();
      this.getReasons();
    }
    return null;
  }

  componentWillUnmount() {
    this.ref.off();
  }

  getComponent() {
    if (this.props.loggedIn && this.props.user) {
      let activePage = (this.props.user.permissionFlags.VIEW_BY_STUDENT === 'false') ? this.props.activePage : 'viewByStudent'
      let comp = null
      switch (activePage) {
        case 'users':
          comp = <Users {...this.props} />
          break;

        case 'lopStatus':
          comp = <LopStatus {...this.props} />
          break;

        case 'tardy':
          comp = <TardySweep {...this.props} />;
          break;

        case 'rosters':
          comp = <Rosters {...this.props} />;
          break;

        case 'library':
          comp = <Library {...this.props} />;
          break;

        case 'gpa':
          comp = <GPA {...this.props} />;
          break;

        case 'check':
          comp = <Check {...this.props} />;
          break;

        case 'reports':
          comp = <Reports {...this.props} />;
          break;

        case 'viewByStudent':
          comp = <ViewByStudent {...this.props} />;
          break;

        default:
          break;
      }
      return comp
    } else {
      return null
    }
  }

  getStudentList() {
    let _this = this;
    this.ref.orderByChild('inactive')
      .equalTo(false)
      .on('value', snapshot => {
        let recs = R.values(snapshot.val());
        recs = R.reject(rec => rec.inactive, recs);
        let objs = R.reduce((acc, rec) => {
          acc[rec.stuID] = rec;
          return acc;
        }, {}, recs)
        _this.props.dispatch('DATA:STUDENT_LIST_OBJ', objs);
      })
  }

  getReasons() {
    let _this = this;
    this.props.db.ref('reasons').on('value', snapshot => {
      _this.props.dispatch('DATA:REASONS',
        R.sort((a,b) => (a.reason < b.reason) ? -1 : 1, R.values(snapshot.val())));
    })
  }

  render() {
    return (
      <div>
        {this.getComponent()}
      </div>
    )
  }
}

export default Main



// WEBPACK FOOTER //
// ./src/views/Main.js